import { IIdsRequest } from "../models/request/base/IIdsRequest";
import { IChieuCaoCanNangSelectByLopRequest } from "../models/request/dan-thuoc/IChieuCaoCanNangSelectByLopRequest";
import { IChieuCaoCanNang } from "../models/response/dan-thuoc/IChieuCaoCanNang";
import { apiClient } from "./apiClient";

export const chieuCaoCanNangApi = {
    selectByLop: (request: IChieuCaoCanNangSelectByLopRequest) =>
        apiClient.get(`chieu-cao-can-nang/nam-hoc/${request.nam_hoc}/lop/${request.dm_lop_id}/thang/${request.thang ?? 0}`),
    save: (model: IChieuCaoCanNang) => apiClient.post(`chieu-cao-can-nang`, model),
    delete: (id: number) => apiClient.get(`chieu-cao-can-nang/${id}`),
    sendNotifyAsync: (request:IIdsRequest) => apiClient.put(`chieu-cao-can-nang/send-notify`,request),
}